<template>
  <div class="sky-date-range">
    <sky-suffix v-bind="$attrs">
        <el-date-picker v-model="TimeValueS" size="medium"  @change="outValue" v-bind='$attrs' :placeholder="placeholders[0]"
          :picker-options="pickerOptionStart"  value-format="yyyy-MM-dd"
      >
        </el-date-picker>
        <el-col class="line" :span="1">-</el-col>
        <el-date-picker v-model="TimeValueE" size="medium" @change="outValue" v-bind='$attrs'   :picker-options="pickerOptions"
        :placeholder="placeholders[1]"  value-format="yyyy-MM-dd">
        </el-date-picker>
    </sky-suffix>
  </div>
</template>
<script>
import SkySuffix from '../formComponents/SkySuffix.vue'
import formStore from '@/mixins/formStore.js'
export default {
  name: 'sky-date-range',
  props: ['placeholders', 'value', 'delay'],
  inheritAttrs: false,
  components: {
      SkySuffix
    },
  data () {
    return {
      TimeValueS: '',
      TimeValueE: '',
      time: [],
      pickerOptions: {
        disabledDate: (val) => {
          let controlTime = Date.parse(this.TimeValueS)
          if (controlTime) {
            return val.getTime() < controlTime
          }
        }
      },
      pickerOptionStart: {
        disabledDate: (val) => {
          let controlEndTime = Date.parse(this.TimeValueE)
          if (controlEndTime) {
            return val.getTime() > controlEndTime
          }
        }
      }
    }
  },
  methods: {
    setVal () {
      this.$emit('input', this.time)
    },
    getVal () {
      this.time = this.value
      this.TimeValueS = this.value[0]
      this.TimeValueE = this.value[1]
    },
    outValue (val) {
      !this.delay && this.delay !== '' && this.setVal()
      this.$emit('change', this.time)
    }
  },
  watch: {
    value: {
      handler: function (val, oldVal) {
        if (val.length > 0) {
          this.TimeValueS = val[0]
          this.TimeValueE = val[1]
        } else {
          this.TimeValueS = ''
          this.TimeValueE = ''
        }
      },
      immediate: true
    },
    TimeValueS: {
      handler: function (val, oldVal) {
        if (val) {
          this.time[0] = val
        } else {
          this.time[0] = ''
        }
      },
      deep: true
    },
    TimeValueE: {
      handler: function (val, oldVal) {
        if (val) {
          this.time[1] = val
        } else {
          this.time[1] = ''
        }
      },
      deep: true
    },
    placeholders: {
      handler: function (val, oldVal) {
      },
      immediate: true
    }
  },
  computed: {
  },
  mounted () {
  }

}
</script>
<style scoped lang="scss">
 .line{
   text-align: center;
 }
 .el-date-editor.el-input, .el-date-editor.el-input__inner{
   width:100%
 }
</style>
